<script>
    // import Warning from '../icons/Warning.svelte';
    import { fade } from 'svelte/transition';
    import { updateApp } from '../store';

    let openModal = true;

    //todo add translations
    let language = "en";
    let no = "Not Now";
    let yes = "Update";
    let header = 'Update Available';
    language = getLang(navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage);

    let reloadText = 'A new version of this App is available.';
    switch (language) {
        case 'es':
            reloadText = 'Una nueva versión de esta aplicación está disponible.';
            yes = 'Actualizar';
            no = 'Ahora No';
            header = 'Actualización Disponible'
            break;
        case 'fr':
            reloadText = 'Une nouvelle version de cette application est disponible. ';
            yes = 'Mettre à jour';
            no = 'Pas Maintenant';
            header = 'Mise à jour Disponible'
            break;
        case 'pt':
            reloadText = 'Está disponível uma nova versão deste aplicativo.';
            yes = 'Atualizar';
            no = 'Agora Não';
            header = 'Atualização Disponível'
            break;
        case 'ru':
            reloadText = 'Доступна новая версия этого приложения. ';
            yes = 'ОБНОВИТЬ';
            no = 'Не Сейчас';
            header = 'Доступно Обновление'
            break;
        case 'zh':
        case 'cn':
            reloadText = '此应用程序的新版本可用。';
            yes = '更新';
            no = '现在不要';
            header = '有可用更新'
            break;
        case 'id':
            reloadText = 'Versi baru dari App ini tersedia.';
            yes = 'Memperbarui';
            no = 'Tidak Sekarang';
            header = 'Pembaruan Tersedia'
            break;
        case 'it':
            reloadText = 'È disponibile una nuova versione di questa applicazione. ';
            yes = 'Aggiornare';
            no = 'Non Adesso';
            header = 'Aggiornamento Disponibile'
            break;
        case 'de':
            reloadText = 'Eine neue Version dieser App ist verfügbar. ';
            yes = 'Aktualisieren';
            no = 'Nicht jetzt';
            header = 'Update Verfügbar'
            break;
        case 'jp':
            reloadText = 'このアプリの新しいバージョンが利用可能です。';
            yes = '更新';
            no = '今はやめろ';
            header = '利用可能なアップデート'
            break;
        default:
            reloadText = 'A new version of this App is available.';
    }

    function rippleClick(e){
        createRipple(e);

        setTimeout(() => {
            openModal = false;
            window.location.reload();
        }, 400);
    }

    function createRipple(event) {

        const button = document.getElementsByClassName('notify-button')[0]

        //get start of footer
        const rect = button.getBoundingClientRect();
        const x = event.clientX - rect.left; //x position within the element.
        const y = event.clientY - rect.top;  //y position within the element.

        const circle = document.createElement("span");
       // const diameter = Math.min(button.offsetHeight, button.offsetWidth, 100);
        const diameter = button.clientWidth/8;
        const radius = diameter/2;
        //dia = Math.min(this.offsetHeight, this.offsetWidth, 100), //
        circle.style.width =  `${diameter}px`;
        circle.style.height = `${diameter}px`;
        circle.style.left = x - radius +'px';//`${event.clientX - (button.offsetLeft + radius)}px`;
        circle.style.top = y - radius +'px';//`${event.clientY - (event.offsetY + radius)}px` //`${event.clientY - restHeight - (button.offsetTop + radius)}px`;
        circle.classList.add("ripple");

        const ripple = button.getElementsByClassName("ripple")[0];

        if (ripple) {
            ripple.remove();
        }

        button.appendChild(circle);
          //auto remove
        setTimeout(()=>{
            const ripDone = button.getElementsByClassName("ripple")[0];
            if (ripDone) {
                ripDone.remove();
            }
        },400)

    }

    function notNow(){
        openModal = false;   
        setTimeout(() => {
            updateApp.set(false);
        }, 400);
    }
    

</script>


<div class="bg-modal" in:fade>
</div>

<div class="modal">
    <div id="notify-view">
        <div class="notify-container  {openModal === true ? 'transIn' : 'transOut'}">
            <div id="notify-content" class="model-content">
                <h3>{header}</h3>
                <p>{reloadText}</p>
                <div class= "notify-button user-color-background yes" on:click="{(event) => rippleClick(event)}">{yes}</div>
                <div class="notify-text-button close" on:click={()=> notNow()}>{no}</div>
            </div>
        </div>
    </div>
</div>


<style>

.modal{
    position:absolute;
    top: 0;
    left:0;
    min-width: 100%;
    min-height: 100%;
    z-index: 9999;
    /* background: rgba(0,0,0,.5); */
    display: flex;
    align-content: center;
    align-items: flex-end;
    justify-content: center;
}

.bg-modal{
    position:absolute;
    top: 0;
    left:0;
    min-width: 100%;
    min-height: 100%;
    z-index: 9999;
    background: rgba(0,0,0,.5);
    display: flex;
    align-content: center;
    align-items: flex-end;
    justify-content: center;
}

    .notify-container{
        background-color: #fff;
        border-radius: 20px;
        width:calc(100% - 20px);
        height: 100%;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        flex-flow: row;
        flex-wrap: wrap;
        margin: 10px;
    }

    .model-content{
        max-width: 600px;
        min-height: 150px;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        flex-flow: row;
        flex-wrap: wrap;
        padding: 20px 20px;
    }

    .model-content p{
        min-width: 100%;
        text-align: center;
    }
    
    .notify-button {
        color: #fff;
        border-radius: 12px;
        min-width: 100px;
        margin: 10px 0px 5px;
        width: 100%;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        font-size: 18px;
        font-weight: 600;
        height: 50px;

        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;

        transition: background 400ms;
        
        overflow: hidden;
        position: relative;
        outline: 0;
    }
       
    .notify-text-button{
        font-weight: bold;
        color:var(--user-color);
        width:100%;
        text-align: center;
        cursor: pointer;
        margin: 10px 0px;
        font-size: 18px;
    }

    h3{
        margin: 10px 0px 0px;
        font-size: 34px;
        text-align: center;
    }
    
    @keyframes tran-out{
        0% {
            transform: translateY(0%);
		}
		100% {
            opacity: 100%;

            transform: translateY(100%);
		}
    }

    @keyframes tran-in{
        0% {
            transform: translateY(100%);
		}
		100% {
            transform: translateY(0%);
		}
    }
    
        .transOut {
            animation: tran-out 400ms  ease-in;
        }
        
        .transIn {
            animation: tran-in 400ms  ease-in;            
        }


    :global(span.ripple){
        position: absolute;
        border-radius: 50%;
        transform: scale(0);
        animation: ripple 300ms linear;
        background-color: rgba(255, 255, 255, 0.7);
    }
        @keyframes ripple {
            to {
                transform: scale(8);
                opacity: 0;
            }
        }

    
    
</style>